import type { FigureUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteFigureFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: FigureUpdatePanelFragment;
};

export function FigureUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteFigureFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("FigureUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
